import React, { useEffect, useState, useContext } from "react";
import { Spinner } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import axios from "../../context/AxiosInstance";
import { AuthContext } from "../../context/AuthContext";
import { STATS_COLORS, barChartOptionsCount } from "./statsChartSetup";

const StatsTabConges = ({ active, annee }) => {
  const { token } = useContext(AuthContext);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const anneeNum = annee === "all" ? new Date().getFullYear() : parseInt(annee, 10);

  useEffect(() => {
    if (!active || !token) return;
    const load = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`/statistiques/conges?annee=${anneeNum}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setRows(res.data.data || []);
      } catch {
        setRows([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [active, token, anneeNum]);

  if (loading) {
    return <div className="stats-loading"><Spinner animation="border" /> Chargement congés…</div>;
  }

  const barData = {
    labels: rows.map((d) => d.mois?.slice(0, 3)),
    datasets: [
      {
        label: "Jours pris",
        data: rows.map((d) => d.jours_pris),
        backgroundColor: STATS_COLORS.primary,
        borderRadius: 6,
      },
      {
        label: "Jours acquis",
        data: rows.map((d) => d.jours_acquis),
        backgroundColor: STATS_COLORS.successSoft,
        borderColor: STATS_COLORS.success,
        borderWidth: 2,
        borderRadius: 6,
      },
    ],
  };

  const totalPris = rows.reduce((s, r) => s + (r.jours_pris || 0), 0);

  return (
    <div className="stats-tab-content">
      <div className="stats-alert-info mb-3">
        Congés pour l&apos;année <strong>{anneeNum}</strong>
        {annee === "all" && " (année en cours utilisée par défaut)"}
        — Total jours pris : <strong>{totalPris.toFixed(1)}</strong>
      </div>
      <div className="stats-panel">
        <h6 className="stats-panel-title">Jours de congé par mois</h6>
        <div className="stats-chart-box stats-chart-tall">
          <Bar
            data={barData}
            options={{
              ...barChartOptionsCount,
              plugins: {
                ...barChartOptionsCount.plugins,
                legend: { ...barChartOptionsCount.plugins.legend, position: "top" },
                tooltip: {
                  ...barChartOptionsCount.plugins.tooltip,
                  callbacks: {
                    label: (ctx) => `${ctx.dataset.label}: ${ctx.raw} jours`,
                  },
                },
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default StatsTabConges;
